import LegalLayout from "./LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout eyebrow="Rechtliches" title="Datenschutzerklärung">
      <section>
        <p className="text-lg">
          Der Schutz Ihrer persönlichen Daten ist uns ein grosses Anliegen. Nachfolgend informieren wir Sie über die Erhebung und Verarbeitung personenbezogener Daten bei der Nutzung unserer Website — im Einklang mit dem Schweizer Datenschutzgesetz (revDSG) und, sofern anwendbar, der EU-Datenschutz-Grundverordnung (DSGVO).
        </p>
      </section>

      <section>
        <h2 className="font-serif-editorial text-3xl mb-3">1. Verantwortliche Stelle</h2>
        <p><strong>Hudak Enterprises</strong><br />
        Matej Hudak (Inhaber &amp; CEO)<br />
        Sonnrainstrasse 13, 3510 Konolfingen, Schweiz<br />
        E-Mail: mhudak@hudakenterprises.ch<br />
        Telefon: +41 77 435 15 61</p>
      </section>

      <section>
        <h2 className="font-serif-editorial text-3xl mb-3">2. Erhebung und Verarbeitung von Daten</h2>
        <p>Beim Besuch unserer Website werden auf unseren Servern temporär sogenannte Server-Logdateien gespeichert (z.B. anonymisierte IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seite, Referrer-URL, verwendeter Browser). Diese Daten dienen der technischen Sicherheit sowie der statistischen Auswertung.</p>
        <p>Wenn Sie mit uns in Kontakt treten (z.B. über das Kontaktformular oder per E-Mail), werden die von Ihnen mitgeteilten Daten (Name, Firma, E-Mail-Adresse, Telefonnummer, Nachricht) zur Bearbeitung Ihrer Anfrage und für den Fall von Anschlussfragen gespeichert. Rechtsgrundlage: Erfüllung vorvertraglicher Massnahmen und berechtigtes Interesse (revDSG bzw. Art. 6 Abs. 1 lit. b und f DSGVO).</p>
      </section>

      <section>
        <h2 className="font-serif-editorial text-3xl mb-3">3. Kontaktformular</h2>
        <p>Beim Versand des Kontaktformulars werden Ihre Angaben in unserer Datenbank (MongoDB) gespeichert sowie zusätzlich per E-Mail an uns übermittelt (über den transaktionalen E-Mail-Dienstleister Resend, Ireland). Ihre Daten werden ausschliesslich zur Bearbeitung Ihrer Anfrage verwendet und nicht für Werbezwecke weitergegeben.</p>
      </section>

      <section>
        <h2 className="font-serif-editorial text-3xl mb-3">4. Cookies &amp; Zustimmung</h2>
        <p>Diese Website verwendet <strong>technisch notwendige Cookies</strong> zur einwandfreien Funktion sowie — nur nach Ihrer ausdrücklichen Zustimmung — <strong>Marketing-Cookies</strong>. Beim ersten Besuch werden Sie über einen Cookie-Banner um Ihre Wahl gebeten. Sie können Ihre Entscheidung jederzeit über den Link „Cookie-Einstellungen" im Footer widerrufen oder anpassen.</p>
      </section>

      <section>
        <h2 className="font-serif-editorial text-3xl mb-3">5. Meta Pixel (Facebook / Instagram)</h2>
        <p>Nach Ihrer ausdrücklichen Zustimmung setzen wir das <strong>Meta Pixel</strong> (Betreiber: Meta Platforms Ireland Limited, 4 Grand Canal Square, Dublin, Irland) ein. Damit können wir messen, welche Werbeanzeigen auf Facebook und Instagram zu Anfragen führen (Conversion-Tracking) und pseudonymisierte Zielgruppen für Werbezwecke bilden (Custom Audiences / Lookalikes).</p>
        <p>Verarbeitet werden dabei u.a. Ihre gekürzte IP-Adresse, technische Browserinformationen, aufgerufene Seiten, Klicks und Formularinteraktionen (Event „Lead" beim Absenden des Kontaktformulars). Die Daten werden an Meta in die USA übertragen; die Übermittlung erfolgt auf Basis des <em>EU-U.S. Data Privacy Frameworks</em> sowie Standardvertragsklauseln. Rechtsgrundlage: Ihre Einwilligung (Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 6 Abs. 1 revDSG).</p>
        <p>Weitere Informationen: <a href="https://www.facebook.com/privacy/policy" target="_blank" rel="noreferrer noopener" className="underline hover:text-[#C9A961]">Datenrichtlinie von Meta</a>. Sie können Ihre Einwilligung jederzeit im Cookie-Banner widerrufen.</p>
      </section>

      <section>
        <h2 className="font-serif-editorial text-3xl mb-3">6. Dienstleister &amp; Drittanbieter</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Hosting: GoDaddy</li>
          <li>E-Mail-Versand: Resend (Ireland)</li>
          <li>Meta Pixel: Meta Platforms Ireland Limited (Facebook / Instagram)</li>
          <li>Schriftarten: Google Fonts</li>
        </ul>
      </section>

      <section>
        <h2 className="font-serif-editorial text-3xl mb-3">7. Ihre Rechte</h2>
        <p>Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer personenbezogenen Daten sowie das Recht auf Datenübertragbarkeit und Widerspruch. Wenden Sie sich hierfür an mhudak@hudakenterprises.ch.</p>
      </section>

      <section>
        <h2 className="font-serif-editorial text-3xl mb-3">8. Datensicherheit</h2>
        <p>Wir verwenden aktuelle technische und organisatorische Massnahmen, um Ihre Daten gegen Manipulation, Verlust, Zerstörung oder unbefugten Zugriff zu schützen. Die Übertragung erfolgt verschlüsselt (TLS/HTTPS).</p>
      </section>

      <section>
        <h2 className="font-serif-editorial text-3xl mb-3">9. Aufsichtsbehörde</h2>
        <p>Zuständige Aufsichtsbehörde: Eidgenössischer Datenschutz- und Öffentlichkeitsbeauftragter (EDÖB), Feldeggweg 1, 3003 Bern.</p>
      </section>

      <p className="font-mono-eyebrow text-[#0A0A0A]/50 pt-4">Stand: Dezember 2026</p>
    </LegalLayout>
  );
}
